<template>
  <el-tabs v-if="!isOnlyClaim" v-model="activeTab">
    <el-tab-pane
      v-for="(name, id) in showLevelOneAppealMap"
      :key="+id"
      :label="name"
      :name="id"
      lazy
    >
      <combine-table :mode="+id"></combine-table>
    </el-tab-pane>
  </el-tabs>

  <combine-table v-else :mode="LEVEL_ONE_APPEAL.CP_NOTICE.code"></combine-table>
</template>

<script>
import { pick, omit } from 'lodash-es'
import { mapGetters } from 'vuex'
import {
  LEVEL_ONE_APPEAL,
  levelOneAppealMap,
} from '../../const'
import CombineTable from './components/CombineTable.vue'

export default {
  name: 'SongList',
  components: {
    CombineTable
  },
  data() {
    return {
      LEVEL_ONE_APPEAL,
      levelOneAppealMap,

      activeTab: '0'
    }
  },
  computed: {
    ...mapGetters(['isOnlyInfringement', 'isOnlyClaim']),
    /**
     * @returns {Object}
     */
    showLevelOneAppealMap() {
      if (this.isOnlyInfringement) {
        return omit(levelOneAppealMap, [LEVEL_ONE_APPEAL.CP_NOTICE.code])
      } else if (this.isOnlyClaim) {
        return pick(levelOneAppealMap, [LEVEL_ONE_APPEAL.CP_NOTICE.code])
      }

      return levelOneAppealMap
    }
  },
}
</script>
